// extracted by mini-css-extract-plugin
export default {"container":"search_main-module__container--3dpC9","filtersContainer":"search_main-module__filtersContainer--lGo2s","filtersOpen":"search_main-module__filtersOpen--1ZHsy"};